import React, { useMemo } from 'react';
import { When, Switch, Case, Default } from 'react-if';
import PropTypes from 'prop-types';
import { CardBody, Row, Col } from 'reactstrap';
import Linkify from 'react-linkify';
import './styles.css';
import { DEFAULT_IMAGE } from '../../../../configs';
import CustomCarousel from '../../../../components/elements/Carousel/Carousel';
import * as QUESTION from '../../../../constants/questions';
import MultipleQuestionItem from '../../../../components/elements/MultipleQuestionItem/MultipleQuestionItem';

const PostBody = ({
    title,
    description,
    media,
    questionType,
    questions,
    showModalImage,
    onMultipleClick,
}) => {
    const showCarousel = media.length > 0;

    const postImages = useMemo(() => {
        return media.length > 0 ? media : [DEFAULT_IMAGE];
    }, [media]);

    return (
        <CardBody className="p-0 card-body-content">
            <Linkify
                componentDecorator={(decoratedHref, decoratedText, key) => (
                    <a target="blank" href={decoratedHref} key={key}>
                        {decoratedText}
                    </a>
                )}
            >
                <Row className="card-body-content">
                    <When condition={showCarousel}>
                        <Col md={5}>
                            <CustomCarousel
                                showModalImage={showModalImage}
                                postImages={postImages}
                            />
                        </Col>
                    </When>
                    <Col md={showCarousel ? 7 : 12}>
                        <div className="post-body__container">
                            <Switch>
                                <Case condition={questionType === QUESTION.MULTIPLE && !showCarousel}>
                                    <div className="d-flex justify-content-center">
                                        <h5 className="multiple-questions__title">{title}</h5>
                                    </div>
                                </Case>
                                <Default>
                                    <h5>{title}</h5>
                                </Default>
                            </Switch>
                            <Switch>
                                <Case condition={questionType === QUESTION.MULTIPLE}>
                                    {questions.map((question, index) => (
                                        <MultipleQuestionItem
                                            activeTabPosts={111}
                                            key={question.uid}
                                            index={index}
                                            question={question}
                                            onMultipleClick={onMultipleClick}
                                            isReview={true}
                                            showCarousel={showCarousel}
                                        />
                                    ))}
                                </Case>
                                <Default>
                                    <p>{description}</p>
                                </Default>
                            </Switch>
                        </div>
                    </Col>
                </Row>
            </Linkify>
        </CardBody>
    );
};

PostBody.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    media: PropTypes.array.isRequired,
    questionType: PropTypes.number.isRequired,
    questions: PropTypes.array.isRequired,
    onMultipleClick: PropTypes.func.isRequired,
    showModalImage: PropTypes.bool,
};

PostBody.defaultProps = {
    showModalImage: false,
};

export default React.memo(PostBody);
